import { useState } from "react";
import type { Archive } from "@/mocks/gossip";

interface Props {
  archive: Archive;
  img: string;
  alt: string;
}

export default function ArchiveCard({ archive, img, alt }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <div className="relative overflow-hidden">
        <img src={img} alt={alt} className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute left-3 top-3 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-white">
          {archive.cat}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-700">
          <i className="ri-time-line text-accent-600"></i>
          {archive.duration}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1 rounded bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
            <i className="ri-record-circle-line"></i>
            {archive.status}
          </span>
          <div className="flex flex-wrap gap-1.5">
            {archive.tags.map((t) => (
              <span key={t} className="text-xs text-foreground-500">#{t}</span>
            ))}
          </div>
        </div>
        <h3 className="mt-2.5 text-lg font-bold leading-snug text-foreground-900">
          {archive.title}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{archive.lead}</p>

        <button
          onClick={() => setOpen((v) => !v)}
          className="mt-4 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-200"
        >
          <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
          {open ? "收起时间线" : `展开时间线（${archive.timeline.length} 节点）`}
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-100 px-5 py-4">
          <div className="relative ml-1.5 flex flex-col gap-4 border-l-2 border-accent-300 pl-5">
            {archive.timeline.map((node) => (
              <div key={node.time} className="relative">
                <span className="absolute -left-[26px] top-1 h-3 w-3 rounded-full border-2 border-accent-500 bg-background-50"></span>
                <p className="text-xs font-bold tracking-wide text-primary-700">{node.time}</p>
                <p className="mt-0.5 text-sm font-semibold text-foreground-900">{node.title}</p>
                <p className="mt-0.5 text-[13px] leading-6 text-foreground-600">{node.desc}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </article>
  );
}